import imageUrlBuilder from "@sanity/image-url";
import createImageUrlBuilder from "@sanity/image-url";
import sanityClient from "@sanity/client";

export const client = sanityClient({
  projectId: "fmuufuap",
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  token:
    "skAuhmdGP6KQPejGznSGrfd8vmyO1RFgtBNTVy56GeoDeZBh7zAe1s3Fg6SlmXd1wNXareOfwfmYgbAz5PzMPl0kUUM6hKdJqiFOSzEKwCb3tF1P5AURi0Yj1Z031sFQwaMHElJsy1Elj6MsysExvmZVoO2KpktpsDhGkyqds2SePay9Gbqt",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
// export const urlFor = (source) => imageUrlBuilder(config).image(source);
